import { useActiveLayerContext } from '@/context/__project__/ActiveLayerContext'
import { useAdaptiveTextColor, useCompContext, useCompFormContext } from '@/context/__project__/CompContext'

import { CompCheckboxWrapperCore } from '../core/forms/checkbox/wrapper'
import { CompCheckbox } from './CompCheckbox'

/**
 * CompCheckboxWrapper
 */
const CompCheckboxWrapper = () => {
  // infos
  const compContext = useCompContext()
  const { activeLayer } = useActiveLayerContext()
  const { currentParentBg } = useAdaptiveTextColor()
  const infosProps = { ...compContext, currentParentBg, activeLayer }

  // form
  const formContext = useCompFormContext()

  return (
    <CompCheckboxWrapperCore infos={infosProps} form={formContext}>
      {(props) => <CompCheckbox {...props} />}
    </CompCheckboxWrapperCore>
  )
}


export default CompCheckboxWrapper